export const propsMixin = {
  props: {
    value: String | Object,
    classes: {
      type: String,
      default: 'xs12 sm12 md12 lg12 xl6 pb-3'
    },
    color: {
      type: String,
      default: 'info'
    },
    placeholder: {
      type: String,
      default: 'Escribe aquí'
    },
    hint: {
      type: String,
      default: 'Texto informativo'
    },
    label: String,
    rules: Array,
    required: Boolean,
    box: Boolean,
    outline: Boolean,
    persistentHint: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    sensitive: Function
  }
}